import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    gdprlogs: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_GDPRLOG_SELECT_IDS (store, ids) {
      store.gdprlogs.selectIds = ids
    },
    REMOVE_GDPRLOG_SELECT_IDS (store, ids) {
      store.gdprlogs.selectIds = store.gdprlogs.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_GDPRLOG_SELECT_ID (store, id) {
      store.gdprlogs.selectId = id
    },
    SET_GDPRLOG_FILTERS (store, filters) {
      store.gdprlogs.filters = filters
    },
    SET_GDPRLOG_PAGINATE (store, val) {
      store.gdprlogs.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getGdprlogs: (store, getters) => {
      return store.gdprlogs.selectIds.map((id) => {
        return getters['entities/gdprlogs/find'](id)
      })
    },
    getGdprlogsFilters: (store, getters) => {
      return store.gdprlogs.filters
    },
    getGdprlogsPaginate: (store, getters) => {
      return store.gdprlogs.paginate
    },
    getGdprlog: (store, getters) => {
      return getters['entities/gdprlogs/find'](store.gdprlogs.selectId) || {}
    }
  },
  actions: {
    /*
    selectGdprlogs
    */
    selectGdprlogs ({commit, dispatch, getters, state}, filters) {
      return dispatch('getGdprlogs', filters)
      .then((response) => {
        commit('SET_GDPRLOG_FILTERS', filters)
        commit('SET_GDPRLOG_PAGINATE', response)
        commit('SET_GDPRLOG_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectGdprlogs
    */
    refreshSelectGdprlogs ({commit, dispatch, getters, state}) {
      return dispatch('selectGdprlogs', getters.getGdprlogsFilters)
    },
    /*
    selectGdprlog
    */
    selectGdprlog ({commit, dispatch, getters, state}, id) {
      return dispatch('getGdprlogById', id)
      .then((response) => {
        commit('SET_GDPRLOG_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getGdprlogs
    */
    getGdprlogs ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/gdprlogs`, {params: filters})
      .then((response) => {
        return dispatch('entities/gdprlogs/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.gdprlogs || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getGdprlogById
    */
    getGdprlogById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/gdprlogs/${id}`)
      .then((response) => {
        return dispatch('entities/gdprlogs/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.gdprlogs[0]
      })
    },
    /*
    requestConsent
    */
    requestConsent ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/gdprlogs/request-consent`, data)
      .then((response) => {
        return dispatch('entities/gdprlogs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeGdprlog', response.gdprlogs[0])
        return response.gdprlogs[0]
      })
    },
    /*
    changePlacement
    */
    changeGdprlog ({commit, dispatch, getters, state}, data) {
      dispatch('getCandidateById', data.candidate_id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Gdprlog.js